import { render, staticRenderFns } from "./BasicAskOpinion.vue?vue&type=template&id=7c67d34e&scoped=true&"
import script from "./BasicAskOpinion.vue?vue&type=script&lang=ts&"
export * from "./BasicAskOpinion.vue?vue&type=script&lang=ts&"
import style0 from "./BasicAskOpinion.vue?vue&type=style&index=0&id=7c67d34e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c67d34e",
  null
  
)

export default component.exports